export enum Criteria {
    NAME = 'Name',
    NIN = 'NIN',
    BIRTH_DATE = 'Birth Date',
    ADDRESS = 'Address'
}

export enum OtherPartyRoleType {
  EMPLOYER = "Employer",
}